/* @flow */

import { em, rem } from 'polished';

import { gutter } from 'src/shared/app/base/style/token/grid';
import { disabledOpacity } from 'src/shared/app/base/style/token/opacity';
import { baseFontSize } from '@e180/ui/lib/token/typography';
import { topBarHeight } from 'src/shared/app/nav/style/nav.style';

export default {
  section: {
    position: 'relative',

    marginTop: `calc(${topBarHeight}px + ${rem(8, baseFontSize)})`,
    padding: [0, gutter],
  },
  header: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,

    width: '100%',
    maxWidth: 425,
    margin: '0 auto',
    padding: `0 ${gutter}px`,
  },
  form: {
    position: 'relative',

    marginBottom: 0,
    paddingTop: 116,
  },
  'form-isLong': {
    paddingTop: 64,
  },
  'form-isDisabled': {
    opacity: disabledOpacity,

    pointerEvents: 'none',
  },
  group: {
    position: 'relative',
  },
  toggle: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  submit: {
    display: 'flex',
    justifyContent: 'center',

    margin: [em(32, baseFontSize), 0, em(24, baseFontSize)],
  },
  support: {
    textAlign: 'center',
  },
  footer: {
    display: 'block',
    marginTop: rem(3),
  },
};
